import {
  type PathLookupGraphPreset,
  type TopologyGraphPreset,
  isPathLookupGraphPreset,
  isTopologyGraphPreset,
} from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import {
  updatePathlookupPresetInLocalStorage,
  updateTopologyPresetInLocalStorage,
} from 'components/Graph/model/presetLocalStorage';

export interface SetAppliedPresetCommand {
  preset: TopologyGraphPreset | PathLookupGraphPreset;
}

export const setAppliedPreset: GraphCommandFactory<SetAppliedPresetCommand> =
  (cmdContext) => (command) => {
    const { preset } = command;
    if (isTopologyGraphPreset(preset)) {
      cmdContext.updateState((draft) => {
        draft.layoutSettings.preset = preset;
        draft.layoutSettings.presetDraft = preset;
      });
      updateTopologyPresetInLocalStorage(preset);
    } else if (isPathLookupGraphPreset(preset)) {
      cmdContext.updateState((draft) => {
        draft.pathlookup.presetDraft = preset;
        draft.pathlookup.preset = preset;
      });
      updatePathlookupPresetInLocalStorage(preset);
    }
  };
